import React, { ReactElement } from "react";
import { getListItemStyles, getListStyles } from "./styles";
export function BulletListEmailRenderer(_attrs: Record<string, unknown>, children?: ReactElement): ReactElement {
  const styles = getListStyles("bullet");
  return <ul style={styles}>{children}</ul>;
}
export function OrderedListEmailRenderer(attrs: {
  start?: number;
}, children?: ReactElement): ReactElement {
  const styles = getListStyles("ordered");
  return <ol style={styles} start={attrs.start}>
      {children}
    </ol>;
}
export function ListItemEmailRenderer(_attrs: Record<string, unknown>, children?: ReactElement): ReactElement {
  const styles = getListItemStyles();
  return <li style={styles}>{children}</li>;
}